<template>
    <div>
        <el-form :model="userForm" :rules="formRules" label-position="right" ref="userForm" label-width="90px" class="demo-ruleForm">
            <el-input v-model="userForm.userPid" type="hidden" style="width: 98%;"></el-input>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="用户姓名" prop="userName">
                        <el-input ref="userNameEl" v-model="userForm.userName" style="width: 98%" placeholder="输入用户姓名" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="用户帐号" prop="userAccount">
                        <el-input v-model="userForm.userAccount" style="width: 98%" placeholder="请输入用户帐号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="帐号密码" prop="userPassword">
                        <el-input v-model="userForm.userPassword" style="width: 98%" placeholder="请输入帐号密码"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-table
                ref="myRoleTable"
                background="true"
                :height="tableHeight"
                :data="tableData"
                border style="width: 100%;">
            <el-table-column type="selection" width="40"/>
            <el-table-column type="index" label="序号" fixed="left" width="50"/>
            <el-table-column prop="tenantPid" label="企业编号" width="110"/>
            <el-table-column prop="roleName" label="角色名称" width="110"/>
            <el-table-column prop="roleRemark" label="备注信息" />
        </el-table>
        <div style="text-align: center">
            <el-button type="primary" style="width: 120px" :disabled="saveButState" @click="submitForm()" v-html="saveButValue"></el-button>
            <el-button type="danger" style="width: 120px" @click="closeWindow()">关 闭</el-button>
        </div>
        <el-dialog
                title="文件预览"
                size="55%"
                :visible.sync="isview"
                append-to-body>
            <PdfImgViewer ref="pdfImgViewer" :fileName="viewFileName"></PdfImgViewer>
        </el-dialog>
    </div>
</template>
<script>
    import PdfImgViewer from "@/components/pdfview/PdfImgViewer.vue";
    import {appjs} from "@/utiljs/apputil";
    export default {
        components: {
            PdfImgViewer
        },
        props: {
            employeeData: {
                type: Object
            },
            closeWindow: {
                type: Function
            }
        },
        data() {
            return {
                isview:false,
                saveButValue: '保 存',
                tipText:'只能上传jpg/png文件，且不超过500kb',
                saveButState: false,
                innerVisible:false,
                viewFileName:'',
                tableData:[],
                tableHeight: '280px',
                fileList:[],
                userForm: {
                    userPid: '',
                    userName: '',
                    userAccount: '',
                    roleIds:'',
                    userPassword: ''
                },
                formRules: {
                    tenantName: [
                        { required: true, message: '请选择所属企业', trigger: 'blur' }
                    ],
                    userName: [
                        { required: true, message: '请输入用户姓名', trigger: 'blur' }
                    ],
                    userAccount: [
                        { required: true, message: '请输入用户帐号', trigger: 'blur' }
                    ],
                    userPassword: [
                        { required: true, message: '请输入帐号密码', trigger: 'blur' }
                    ],
                }
            }
        },
        created() {
            this.loadRoleTableData();
        },
        methods:{
            resertForm() {
                this.saveButValue = '保 存';
                this.saveButState = false;
                this.$refs['userForm'].resetFields();
                this.userForm.userPid = this.employeeData.employeePid;
                this.userForm.userName = this.employeeData.employeeName;
                this.loadRoleTableData();
            },
            loadRoleTableData(){
                let load = appjs.loading();
                let _self = this;
                let params = this.searchForm;
                appjs.httpRequest('role/queryAllRole',params).then(
                    (data)=>{
                        if(data.retCode&&data.retCode!="ok"){
                            appjs.showErrorMsg(data.retMsg)
                        }else{
                            _self.tableData = data.dataList;
                            this.$refs.myRoleTable.bodyWrapper.scrollTop =0;
                        }
                        appjs.unloading(load);
                    }
                ).catch(
                    (errmsg)=>{
                        appjs.showErrorMsg(errmsg)
                        appjs.unloading(load);
                    });
            },
            submitForm() {
                let roleIds = "";
                this.$refs.myRoleTable.store.states.selection.forEach(item=>{
                    roleIds += item.rolePid+",";
                })
                this.userForm.roleIds = roleIds;
                this.$refs['userForm'].validate((valid) => {
                    if (valid) {
                        let params = this.userForm;
                        if(this.userForm.roleIds==""){
                            appjs.showWarningMsg("请选择角色信息")
                            return;
                        }
                        this.saveButValue = '保存中....'
                        this.saveButState = true;
                        let _self = this;
                        appjs.httpRequest('user/saveEmployeeUser',params).then((data)=>{
                            if(data.retCode&&data.retCode!="ok"){
                                appjs.showErrorMsg(data.retMsg);
                                _self.saveButValue = '保存';
                                _self.saveButState = false;
                            }else{
                                _self.saveButValue = '保存成功';
                                _self.closeWindow(data.retMsg);
                            }
                        }).catch((error)=>{
                            _self.saveButState = false;
                            _self.loginText = '保存';
                            appjs.showErrorMsg("异常：" + error)
                        })
                    } else {
                        return false;
                    }
                });
            }
        }
    }
</script>
